var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio"},[_c('audio',{ref:"audio",attrs:{"src":_vm.url},on:{"loadedmetadata":_vm.onLoadedmetadata}})])
}
var staticRenderFns = []

export { render, staticRenderFns }